<template>
    <v-card class="mx-auto pb-10" tile flat>
        <v-alert v-if="hasNoDataCollector && hasUserContext" dense class="" type="info">You don't have any data collectors yet. Follow these instructions to install them.</v-alert>
        <template v-if="hasNoDataCollector || !hasUserContext">
            <v-card-title class="text-h2">Web Application Data Collector Installation</v-card-title>
            <v-card-title class="text-h3">Installation</v-card-title>
            <v-card-text class="text-body-1">   
                <ssh-pre >
npm install @ravenpod/ravenpod-web-dc
                </ssh-pre>                        
            </v-card-text>
            <v-card-title class="text-h3">Basic Usage</v-card-title>
            <v-card-text class="text-body-1">
                In your NodeJS app, simply 'require' the Ravenpod data collector with the access and secret access key.
                <ssh-pre language="js" label="Javascript">
const express = require("express");
const app = express();
// Enable Ravenpod
require('@ravenpod/ravenpod-web-dc')(app,
    {
        accessKey: '{{ accessKey }}',
        secretAccessKey: '{{ secretAccessKey }}'
    }
);
                </ssh-pre>
            </v-card-text>


            <v-card-title class="text-h2">Chaincode Data Collector Installation</v-card-title>
            <v-card-title class="text-h3">Installation</v-card-title>
            <v-card-text class="text-body-1">   
                <ssh-pre >
npm install @ravenpod/ravenpod-cc-dc
                </ssh-pre>                        
            </v-card-text>
            <v-card-title class="text-h3">Basic Usage</v-card-title>
            <v-card-text class="text-body-1">   
                In your chaincode contract directory, simply 'require' the Ravenpod data collector with the access and secret access key <b>in the beginning of the index.js</b>
                <ssh-pre language="js" label="Javascript">
'use strict';

require('@ravenpod/ravenpod-cc-dc')(
    ['vaccine'], // Array of chaincode contract filename to be instrumented
    {
        accessKey: '{{ accessKey }}',
        secretAccessKey: '{{ secretAccessKey }}'
    }    
)

const Vaccine = require('./lib/vaccine');

module.exports.Vaccine = Vaccine;
module.exports.contracts = [ Vaccine ];
                </ssh-pre>
            </v-card-text>
        </template>

        <v-alert v-if="!hasSubscription && hasUserContext" dense class="" type="info">You don't have any subscription yet</v-alert>
        <template v-if="!hasSubscription && hasUserContext">
            <v-card-title><h2>How to subscribe</h2></v-card-title>
            <v-card-text class="text-body-1">Visit <a target="_blank" href="https://aws.amazon.com/marketplace/seller-profile?id=9766d68d-37bf-4e46-a353-92b508cfe823">our company page</a> on Amazon Marketplace. Choose a subscription and follow the instructions.</v-card-text>
        </template>
    </v-card>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import SshPre from 'simple-syntax-highlighter'
    import 'simple-syntax-highlighter/dist/sshpre.css'
    export default {
        name: 'InstallationGuide',
        components: { SshPre },
        props: {
            hasUserContext: {
                type: Boolean,
                default: true,
                required: false,
            },
        },
        computed: {
            ...mapGetters([
                'webAppNames',
                'currentWebAppName'
            ]),         
            ...mapGetters('auth', {
                hasSubscription: 'hasSubscription',
                currentSubscription: 'currentSubscription'
            }),            
            hasNoDataCollector: function() {
                return (this.hasSubscription && this.webAppNames.length == 0)
            },   
            accessKey: function() {
                if (this.currentUser()) {
                    return this.currentUser().attributes.sub
                } else {
                    return '[YOUR ACCESS KEY]'
                }
            },
            secretAccessKey: function() {
                if (this.currentUser() && this.hasSubscription) {
                    return this.currentSubscription.subscription_secret_access_key
                } else {
                    return '[YOUR SECRET ACCESS KEY]'
                }
            }
        },
        methods: {
        },
        data: function() {
            return {
            }
        },    
    }
</script>

<style scoped lang="scss">
</style>